import { reactive } from 'vue';
import { roleState } from './roles';


export const accessState = reactive({
  permissions: [],
  organizationId: null,
  loaded: false,
  loadingPromise: null,

  can(permission) {
    if (!permission) return true;
    if (this.loaded) return this.permissions.includes(permission);
    return roleState.hasPermission(permission);
  },

  setContext(context = {}) {
    this.permissions = Array.isArray(context.permissions) ? context.permissions : [];
    this.organizationId = context.organization_id ?? null;
    this.loaded = true;
  },

  clear() {
    this.permissions = [];
    this.organizationId = null;
    this.loaded = false;
    this.loadingPromise = null;
  },

  async load(force = false) {
    if (this.loaded && !force) return this;
    if (this.loadingPromise && !force) return this.loadingPromise;

    this.loadingPromise = (async () => {
      try {
        // Dynamic import avoids the api -> router -> access store cycle.
        const { default: api } = await import('@/services/axios');
        const response = await api.get('/auth/access-context');
        this.setContext(response.data || {});
        return this;
      } catch (error) {
        this.permissions = [];
        this.organizationId = null;
        this.loaded = false;
        throw error;
      } finally {
        this.loadingPromise = null;
      }
    })();

    return this.loadingPromise;
  },
});
